import React from 'react';
import AdminYearlySalesChart from './AdminYearlySalesChart';
import AdminCumulativeSalesChart from './AdminCumulativeSalesChart';
import AdminExpenseDoughnutChart from './AdminExpenseDoughnutChart';
import AdminRecentSales from './AdminRecentSales';
import AdminQuickSaleWordCloud from './AdminQuickSaleWordCloud';
import AdminRecentExpenses from './AdminRecentExpenses';
import AdminSalesDistributionChart from './AdminSalesDistributionChart';
import '../styles/SalesCharts.css';
import '../styles/AdminRecentSales.css';
import '../styles/AdminDashboardCharts.css';

const AdminDashboardCharts = ({ selectedPOS }) => {
  return (
    <div className="admin-dashboard-container">
      {/* Sección de gráficas */}
      <div className="sales-charts-container">
        {/* Gráfica de ventas mensuales (enero a diciembre) */}
        <AdminYearlySalesChart selectedPOS={selectedPOS} />
        
        {/* Gráfica de ventas acumuladas (enero a diciembre) */}
        <AdminCumulativeSalesChart selectedPOS={selectedPOS} />
        
        {/* Gráfica de distribución de las ventas por producto */}
        <AdminSalesDistributionChart selectedPOS={selectedPOS} />
        
        {/* Gráfica de Gastos Mensuales por Categoría */}
        <div className="chart-wrapper expense-chart-wrapper">
          <h3>Gastos Mensuales por Categoría</h3>
          <div className="chart-container expense-chart-container">
            <AdminExpenseDoughnutChart selectedPOS={selectedPOS} />
          </div>
        </div>

        {/* Análisis de Venta Rápida (nube de palabras) */}
        <div className="chart-wrapper">
          <h3>Análisis de Venta Rápida</h3>
          <div className="chart-container" style={{ minHeight: 220 }}>
            <AdminQuickSaleWordCloud selectedPOS={selectedPOS} />
          </div>
        </div>
      </div>
      
      {/* Sección de tablas de datos */}
      <div className="dashboard-bottom-section">
        {/* Ventas Recientes */}
        <div className="dashboard-column full-width">
          <AdminRecentSales selectedPOS={selectedPOS} />
        </div>
        
        {/* Gastos Recientes */}
        <div className="dashboard-column full-width">
          <AdminRecentExpenses />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardCharts;
